import typography from '../typography';
import { COLORS } from 'constants/styles';

const MuiFormLabel = {
    root: {
        ...typography.subtitle1,
        '&$focused': {
            color: COLORS.BLUE,
        },
    }
};

export default MuiFormLabel;
